import { render, staticRenderFns } from "./ModalTipoTurno.vue?vue&type=template&id=78e552cf&scoped=true"
import script from "./ModalTipoTurno.vue?vue&type=script&lang=js"
export * from "./ModalTipoTurno.vue?vue&type=script&lang=js"
import style0 from "./ModalTipoTurno.vue?vue&type=style&index=0&id=78e552cf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78e552cf",
  null
  
)

export default component.exports